import apiClient from "../core/HttpClient";
import { PhysicalAndMentalSymptom } from "../models";
import PhysicalAndMentalSymptomViewModel from "../viewModels/PhysicalAndMentalSymptomViewModel";

export default class PhysicalAndMentalSymptomService{
    url="/PhysicalAndMentalSymptoms";

    public async getSymptoms(params?: { parentId?: number | null }): Promise<PhysicalAndMentalSymptom[]> {
        const query = params && Object.prototype.hasOwnProperty.call(params, "parentId")
            ? `?parentId=${params.parentId ?? ""}`
            : "";
        return await apiClient.get(`${this.url}/by-parent${query}`).then((res) => res.data);
    }

    public async getSymptom(id: string): Promise<PhysicalAndMentalSymptomViewModel> {
        return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
    }

    public async createSymptom(model: PhysicalAndMentalSymptom) {
        return await apiClient.post(this.url, model);
    }

    public async updateSymptom(model: PhysicalAndMentalSymptom) {
        return await apiClient.put(`${this.url}`, model);
    }

    public async deleteSymptom(id: number): Promise<void> {
        await apiClient.delete(`${this.url}/${id}`);
    }
}


